import React, { lazy, Suspense, useState, useEffect } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import * as urls from '@/api/urls';

import Spinner from '@/generic-components/Spinner';
import { Helmet } from 'react-helmet';
import Checkout from '@/pages/simo/checkout';
import CeDenied from '@/components/simo/checkout/ceDenied/CeDenied';
import FatalError from '@/components/fatal-error/FatalError';
import GenericErrorPage from '@/components/generic-error-page/GenericErrorPage';
import PageAlert from '@/components/page-alert/page-alert';
import { graphQLClient } from '@/contentful/contentful-config';
import { alertQuery } from '@/contentful/queries';

const Subscriptions = lazy(() => import('@/pages/simo/subscriptions'));
const TopNavigation = lazy(() => import('@/generic-components/top-navigation'));
const Login = lazy(() => import('@/generic-components/login/login'));
const Subscription = lazy(() => import('@/pages/simo/subscription'));
const Basket = lazy(() => import('@/pages/simo/basket'));
const Configuration = lazy(() => import('@/pages/simo/configuration'));
const NemID = lazy(() => import('@/pages/simo/nemID/nemID'));
const MitID = lazy(() => import('@/pages/simo/mitID/mitID'));
const Receipt = lazy(() => import('@/pages/simo/receipt/receipt'));

const Routes = () => {
  const [alert, setAlert] = useState<any>();

  useEffect(() => {
    const fetchAlert = async () => {
      try {
        const alertResponse = await graphQLClient.request(alertQuery);
        setAlert(alertResponse.alertCollection.items[0]);
      } catch (error) {
        console.log(error);
      }
    };

    fetchAlert();
  }, []);

  return (
    <>
      <>
        <Helmet>
          <title>Mobilabonnement på DK's bedste 5G-mobilnetværk - Bestil her</title>
        </Helmet>
        {alert?.fullPageRedirect ? (
          <Suspense fallback={<Spinner />}>
            <Redirect push to={urls.genericError.pattern} />
            <Route
              exact
              path={urls.genericError.pattern}
              render={() => (
                <>
                  <GenericErrorPage display={true} alert={alert} />
                </>
              )}
            />
          </Suspense>
        ) : (
          <Suspense fallback={<Spinner />}>
            <>
              <Login />
              <Switch>
                <Route
                  exact
                  path={urls.configuration.pattern}
                  render={(props: any) => (
                    <>
                      <PageAlert alert={alert} />
                      <Configuration {...props} />
                    </>
                  )}
                />
                <Route
                  exact
                  path={urls.basket.pattern}
                  render={(props: any) => (
                    <>
                      <PageAlert alert={alert} />
                      <Basket {...props} />
                    </>
                  )}
                />
                <Route
                  exact
                  path={urls.checkout.pattern}
                  render={(props: any) => (
                    <>
                      <PageAlert alert={alert} />
                      <Checkout {...props} />
                    </>
                  )}
                />
                <Route
                  exact
                  path={urls.paymentSuccess.pattern}
                  render={(props: any) => (
                    <>
                      <PageAlert alert={alert} />
                      <Checkout {...props} />
                    </>
                  )}
                />
                <Route
                  exact
                  path={urls.nemID.pattern}
                  render={(props: any) => (
                    <>
                      <PageAlert alert={alert} />
                      <NemID {...props} />
                    </>
                  )}
                />

                <Route
                  exact
                  path={urls.mitID.pattern}
                  render={(props: any) => (
                    <>
                      <PageAlert alert={alert} />
                      <MitID {...props} />
                    </>
                  )}
                />

                <Route
                  exact
                  path={urls.receipt.pattern}
                  render={(props: any) => (
                    <>
                      <PageAlert alert={alert} />
                      <Receipt {...props} />
                    </>
                  )}
                />

                <Route exact path={urls.ceDenied.pattern} component={CeDenied} />
                <Route path={urls.fatalError.pattern} component={FatalError} />

                <Route
                  exact
                  path={urls.genericError.pattern}
                  render={() => (
                    <>
                      <GenericErrorPage alert={alert} />
                    </>
                  )}
                />
                <>
                  <TopNavigation />
                  <Route
                    exact
                    path={urls.subscription.pattern}
                    render={(props: any) => (
                      <>
                        <PageAlert alert={alert} />
                        <Subscription {...props} />
                      </>
                    )}
                  />
                  <Route
                    exact
                    path={urls.simo.pattern}
                    render={(props: any) => (
                      <>
                        <PageAlert alert={alert} />
                        <Subscriptions {...props} />
                      </>
                    )}
                  />
                </>
              </Switch>
            </>
          </Suspense>
        )}
      </>
    </>
  );
};
export default withRouter(Routes);
